import { message } from "antd";
import { usePatchCaptureMutation } from "../../actions/capture";
import { usePatchDetectionMutation } from "../../actions/detection";
import { useInvalidateCatalogMutation } from "../../actions/catalogInQuery";
import { Capture } from "../../types/api/models/capture";
import { Detection } from "../../types";
import { isDetection } from "./isDetection";
import { useRouteType } from "./useRouteType";

export interface SpecimenFormValues {
  species?: string;
  notes?: string;
}

export function useSpecimenSubmit(
  id: string,
  item: Capture | Detection | undefined,
) {
  const { isMeshRoute } = useRouteType();
  const [patchCapture, { isLoading: isUpdatingCapture }] =
    usePatchCaptureMutation();
  const [patchDetection, { isLoading: isUpdatingSpecimen }] =
    usePatchDetectionMutation();
  const [invalidateCatalog] = useInvalidateCatalogMutation();

  const handleSubmit = async (values: SpecimenFormValues) => {
    try {
      if (isMeshRoute) {
        await patchCapture({
          id,
          data: {
            notes: values.notes,
            updatedOn: new Date(),
          },
        }).unwrap();
      } else {
        const previousSpecies =
          item && isDetection(item) ? item.contributed_species : undefined;
        await patchDetection({
          id,
          data: {
            contributed_species: values.species,
            notes: values.notes,
          },
        }).unwrap();
        if (values.species !== previousSpecies) {
          invalidateCatalog();
        }
      }
      message.success("Successfully updated!");
    } catch (err) {
      console.error("Failed to update:", err);
      message.error("Failed to save changes. Please try again.");
    }
  };

  return {
    handleSubmit,
    isSubmitting: isUpdatingCapture || isUpdatingSpecimen,
  };
}
